import React, { useState } from "react";
import { ListItem, TextField } from "@material-ui/core";
import EditImage from "../EditArticle/EditImage";
import { updateAllergen, updateAllergenImage } from "../../store/AllergenApi";
import { Allergen } from "../../store/articles/models/Allergen";
import Grid from "@material-ui/core/Grid";

function AllergenView(props) {
  const [allergen, setAllergen] = useState(props.allergen);
  return (
    <ListItem>
      <Grid container spacing={3}>
        <Grid container item xs={8} alignItems={"center"}>
          <TextField
            disabled={allergen.merchant_id == null}
            variant={"outlined"}
            value={allergen.name}
            onChange={(e) => {
              let newAllergen = Object.assign(new Allergen(), allergen);
              newAllergen.name = e.target.value;
              setAllergen(newAllergen);
            }}
            onBlur={() => {
              updateAllergen(props.merchantId, allergen, { name: allergen.name }).then(() => {});
            }}
          />
        </Grid>
        <Grid container item xs={4} alignItems={"center"}>
          <EditImage
            authorizationField={"allergens"}
            prefix={""}
            disabled={allergen.merchant_id == null}
            value={allergen.getImagePath()}
            onSave={(image, setImagePath) => {
              updateAllergenImage(props.merchantId, allergen.id, image).then((image) => {
                setImagePath("https://mynober-api-public.s3.eu-central-1.amazonaws.com/" + image);
              });
            }}
            onRemove={(setImagePath) => {
              updateAllergen(props.merchantId, allergen, { image: null }).then(() => {
                setImagePath(allergen.image);
              });
            }}
          />
        </Grid>
      </Grid>
    </ListItem>
  );
}

export default AllergenView;
